import React, { Suspense } from 'react';

import { lazyNamed } from '@/components/lazyRoute';
import * as Sentry from '@/sentry';

const CommandPalette = lazyNamed(() => import('./KBar'), 'CommandPalette');

/** If the palette chunk cannot load, the app carries on without the palette and its shortcuts. */
class PaletteBoundary extends React.Component<{ children: React.ReactNode }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error) {
    Sentry.captureException(error);
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}

/**
 * Command palette (Cmd or Ctrl+K) and its keyboard shortcuts, loaded after the app shell renders. The
 * shortcuts work as soon as the chunk arrives, a moment after first paint.
 */
export const LazyCommandPalette = () => (
  <PaletteBoundary>
    <Suspense fallback={null}>
      <CommandPalette />
    </Suspense>
  </PaletteBoundary>
);
